/* eslint-disable jsx-a11y/anchor-is-valid */
import { useAuth, LoginAuditInfo } from '../../auth'

export const Overview = () => {
  const { currentUser: user, auth } = useAuth()

  return (
    <>
      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Detalhes do Perfil</h3>
          </div>
        </div>

        <div className='card-body p-9'>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Nome Completo</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>{user?.pessoa?.nome}</span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Data de Nascimento</label>

            <div className='col-lg-8 fv-row'>
              <span className='fw-bold fs-6'>{user?.pessoa?.dataNascimentoFormatada}</span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>CPF</label>

            <div className='col-lg-8 fv-row'>
              <span className='fw-bold fs-6'>{user?.pessoa?.cpf}</span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Grupo</label>

            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>{user?.grupo?.descricao}</span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>E-mail</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 me-2'>{user?.email}</span>
              <span className={user?.ativo === true ? 'badge badge-success' : 'badge badge-danger'}>
                {user?.ativo === true ? 'Usuário ativo' : 'Usuário inativo'}
              </span>
            </div>
          </div>
        </div>
      </div>

      <LoginAuditInfo auditoria={auth?.auditoria} />
    </>
  )
}
